import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-width: 90px;

  &[data-invalid='true'] input {
    border-color: #cf1919;
    box-shadow: 0 0 0 3px rgba(207, 25, 25, 0.15);
  }
`;

export const Label = styled.label`
  font-size: 0.8571428571428571em;
  font-style: inherit;
  line-height: 1.3333333333333333;
  color: #6b778c;
  font-weight: 600;
  margin-top: 16px;
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 4px;
  margin-top: 0;
`;

export const InputWrapper = styled.div<{ width?: string }>`
  position: relative;
  width: ${(props) => props.width || '6.25rem'};
  border: 2px solid var(--ds-border-neutral, #dfe1e6);
  border-radius: 0.25rem;
`;

export const Input = styled.input`
  width: 100%;
  height: 38px;
  padding: 8px 48px 8px 12px; /* espaço à direita pro sufixo */
  border: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  outline: none;
  text-align: right;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: 0.1s;

  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #9ca3af;
    cursor: not-allowed;
  }
`;

export const Suffix = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  height: 41px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  font-size: 0.85rem;
  color: #475569;
  background-color: #ebecf0;
  pointer-events: none;
  user-select: none;
`;
